<template>
    <div class="card">
        <div class="card-body">
            <div v-for="(block, index) in blocks" v-if="block.fields">
                <hr v-if="index > 0"/>
                <h4 class="card-body__title mb-4" :class="{'mt-4': index > 0}" >
                    <span>{{ block.label }}</span>
                </h4>
                <div class="row">
                    <div class="col-sm-6 mb-2" v-for="field in block.fields">
                        <span class="font-weight-light mr-1 d-block">{{ field.label }}</span>
                        <span class="font-weight-bold d-block">{{ field.displayValue }}</span>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            blocks: {default: () => {return []}}
        }
    }
</script>